import {PurchasePriceRuleTemplate} from '../../../types/PurchasePriceRuleTemplateSchema';
import {toPurchasePriceRuleFormValues} from './toPurchasePriceRuleFormValues';

/** A new rule starts from the template with an empty name and no scope. */
export const templateToFormValues = (template: PurchasePriceRuleTemplate) =>
  toPurchasePriceRuleFormValues(template, {
    name: '',
    scope: {makes: [], modelFamilies: [], trims: []},
  });
